import { useMemo } from "react";
import { useDataContext } from "../Components/DataContext";
import {
  buildPermissionsMap,
  canAccessPath,
  canExportModule,
  canModule,
  canViewModule,
  getActionForPath,
  getModuleForPath,
  getProfilePermissions,
  hasFullAccess,
  isModuleInPermissions,
  isSubAdminUser,
  shouldUsePermissionList,
} from "../utils/permissions";

export const usePermissions = () => {
  const { adminProfile, profileLoaded } = useDataContext();

  const permissionsMap = useMemo(
    () => buildPermissionsMap(getProfilePermissions(adminProfile)),
    [adminProfile]
  );

  const fullAccess = hasFullAccess(adminProfile);
  const subAdmin = isSubAdminUser(adminProfile);

  const can = (moduleName, action = "view") =>
    canModule(moduleName, action, permissionsMap, adminProfile);

  const canView = (moduleName) =>
    canViewModule(moduleName, permissionsMap, adminProfile);

  const canExport = (moduleName) =>
    canExportModule(moduleName, permissionsMap, adminProfile);

  const canPath = (pathname, action) =>
    canAccessPath(pathname, {
      permissionsMap,
      profile: adminProfile,
      action: action ?? getActionForPath(pathname),
    });

  return {
    adminProfile,
    profileLoaded,
    permissionsMap,
    hasFullAccess: fullAccess,
    usesPermissionList: shouldUsePermissionList(adminProfile),
    isSubAdmin: subAdmin,
    isModuleInPermissions: (moduleName) =>
      isModuleInPermissions(moduleName, permissionsMap),
    can,
    canView,
    canExport,
    canPath,
    canModule: can,
    getModuleForPath,
    getActionForPath,
  };
};
